const COMPANY = "Studio Nouvelle S.r.l.";
const ADDRESS = "Via Casa Manzo, 7 — 84135 Salerno (SA)";
const VAT = "02631750656";
const EMAIL = "pgiarletta@gmail.com";
const UPDATED = "22 ottobre 2026";

function Section({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-semibold text-slate-100">{title}</h2>
      <div className="text-sm leading-relaxed text-slate-300 space-y-2">{children}</div>
    </section>
  );
}

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0A0E17] text-slate-200 py-12 px-4" data-testid="terms-page">
      <div className="max-w-3xl mx-auto space-y-8">
        <header className="space-y-2 border-b border-[#1F2937] pb-6">
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-100">Condizioni d'uso</h1>
          <p className="text-sm text-slate-400">{COMPANY} — Ultimo aggiornamento: {UPDATED}</p>
        </header>

        <Section title="1. Oggetto e titolare del servizio">
          <p>Le presenti Condizioni d'uso disciplinano l'accesso e l'utilizzo della piattaforma <strong>Nouvelle WhatsApp</strong> (di seguito «Piattaforma»), un servizio per la gestione di comunicazioni WhatsApp Business (campagne, conversazioni, automazioni e contatti) erogato da <strong>{COMPANY}</strong>, con sede in {ADDRESS} — P.IVA e C.F. {VAT} — email <a href={`mailto:${EMAIL}`} className="text-[#10B981] underline">{EMAIL}</a>.</p>
          <p>La Piattaforma si avvale della WhatsApp Business Platform (Cloud API) di Meta Platforms, Inc.; l'uso di WhatsApp resta soggetto anche ai termini di Meta e di WhatsApp.</p>
        </Section>

        <Section title="2. Accesso e account">
          <p>L'accesso è riservato alle aziende clienti e ai loro operatori autorizzati tramite credenziali personali. L'utente è responsabile della riservatezza delle credenziali e di ogni attività svolta con il proprio account; deve informare tempestivamente {COMPANY} in caso di accesso non autorizzato.</p>
        </Section>

        <Section title="3. Uso consentito">
          <p>La Piattaforma può essere utilizzata esclusivamente per inviare comunicazioni a destinatari che abbiano prestato un <strong>consenso esplicito</strong> (opt-in) a riceverle, nel rispetto del GDPR, del Codice Privacy e delle policy WhatsApp Business (Business Policy, Commerce Policy e Messaging Policy).</p>
          <p>È vietato: inviare messaggi non richiesti (spam), contenuti illeciti, ingannevoli, offensivi o lesivi di diritti altrui; cedere o condividere l'accesso con terzi non autorizzati; interferire con la sicurezza o il funzionamento della Piattaforma; eludere i meccanismi di disiscrizione.</p>
        </Section>

        <Section title="4. Consenso e disiscrizione dei destinatari">
          <p>Ogni messaggio promozionale deve consentire al destinatario di disiscriversi (ad esempio rispondendo «STOP» o utilizzando il pulsante dedicato). Le richieste di disiscrizione sono registrate automaticamente dalla Piattaforma e devono essere rispettate dall'azienda utilizzatrice.</p>
        </Section>

        <Section title="5. Dati personali">
          <p>Il trattamento dei dati personali è descritto nell'<a href="/privacy" className="text-[#10B981] underline">Informativa sulla Privacy</a>. Le modalità per richiedere la cancellazione dei dati sono indicate nella pagina <a href="/data-deletion" className="text-[#10B981] underline">Cancellazione dei dati</a>. Per i dati dei destinatari gestiti dall'azienda cliente, quest'ultima opera come titolare del trattamento e {COMPANY} come responsabile, in base a specifico accordo.</p>
        </Section>

        <Section title="6. Disponibilità del servizio">
          <p>{COMPANY} si impegna a mantenere la Piattaforma disponibile e aggiornata, senza garantire l'assenza di interruzioni. Il servizio dipende da fornitori terzi (Meta/WhatsApp, hosting, connettività): eventuali limitazioni, sospensioni o modifiche imposte da tali fornitori non sono imputabili a {COMPANY}.</p>
        </Section>

        <Section title="7. Costi">
          <p>Le condizioni economiche del servizio sono definite nel contratto o nell'offerta sottoscritta dall'azienda cliente. I costi delle conversazioni WhatsApp applicati da Meta sono addebitati secondo il listino Meta vigente sull'account WhatsApp Business dell'azienda.</p>
        </Section>

        <Section title="8. Proprietà intellettuale">
          <p>La Piattaforma, il software, i marchi e i contenuti forniti da {COMPANY} restano di sua esclusiva proprietà. I contenuti caricati dall'azienda cliente (testi, immagini, modelli di messaggio, elenchi contatti) restano di proprietà del cliente, che ne garantisce la liceità e la titolarità dei diritti.</p>
        </Section>

        <Section title="9. Limitazione di responsabilità">
          <p>Nei limiti consentiti dalla legge, {COMPANY} non risponde dei danni indiretti o derivanti da uso improprio della Piattaforma, da violazione delle policy WhatsApp da parte dell'utente, da blocchi o restrizioni applicati da Meta all'account o al numero del cliente, o da eventi al di fuori del proprio ragionevole controllo.</p>
        </Section>

        <Section title="10. Sospensione e cessazione">
          <p>{COMPANY} può sospendere o interrompere l'accesso in caso di violazione delle presenti Condizioni, delle policy WhatsApp o di norme di legge, oppure su richiesta motivata di Meta. L'azienda cliente può recedere secondo quanto previsto dal contratto; alla cessazione i dati vengono cancellati o restituiti secondo l'Informativa sulla Privacy.</p>
        </Section>

        <Section title="11. Modifiche">
          <p>Le presenti Condizioni possono essere aggiornate; la versione vigente è sempre pubblicata a questa pagina con la data di ultimo aggiornamento. L'uso continuato della Piattaforma dopo la pubblicazione costituisce accettazione delle modifiche.</p>
        </Section>

        <Section title="12. Legge applicabile e foro">
          <p>Le presenti Condizioni sono regolate dalla legge italiana. Per ogni controversia è competente il Foro di Salerno, salvo diversa inderogabile previsione di legge.</p>
        </Section>

        <Section title="13. Contatti">
          <p>Per domande sulle presenti Condizioni: <a href={`mailto:${EMAIL}`} className="text-[#10B981] underline">{EMAIL}</a>.</p>
        </Section>

        <footer className="border-t border-[#1F2937] pt-6 text-xs text-slate-500">
          <a href="/privacy" className="text-[#10B981] underline">Informativa sulla Privacy</a> · <a href="/data-deletion" className="text-[#10B981] underline">Cancellazione dei dati</a>
        </footer>
      </div>
    </div>
  );
}
